<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <MovementTypeForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import MovementTypeForm from '@/components/settings/stock-registers/movementType/MovementTypeForm'

export default {
  name: 'MovementTypeAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    MovementTypeForm
  }
}
</script>
